require('./jobsWidget.style.scss');

const TIME_STEP = 1000 * 60 * 60 * 8; //8h
class JobsWidgetController {
    constructor($scope, $filter, $rootScope, styleService, dashboardService, sharedPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.dateFilter = $filter('localizeDate');
        this._dashboardService = dashboardService;
        this.ENDPOINT = sharedPersistenceService.getRestEndpoints().TASKS_REST;
        this.graphColors = styleService.getGraphColors('jobs');
        this.data = [
            {
                name: 'DONE',
                value: 0,
                iconClass: 'icon-okay',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.tasks.status.success')
            },
            {
                name: 'DONE_WITH_ERRORS',
                value: 0,
                iconClass: 'icon-warning',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.tasks.status.warning')
            },
            {
                name: 'FAILED',
                value: 0,
                iconClass: 'icon-fail',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.tasks.status.failed')
            },
            {
                name: 'RUNNING',
                value: 0,
                iconClass: 'icon-execute',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.tasks.status.inProgress')
            },
        ];
        this.renderCounter = 0;
    }

    $onInit() {
        this.updateData();
        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.updateData();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    updateData() {
        if (!this.widgetData) return;
        let bkpCtrlTime = this.widgetData.backupControllerTime,
            startBctrlTime = bkpCtrlTime || Date.now();

        this.startTime = startBctrlTime;
        this.data[0].value = _.reduce(this.widgetData.successCount, (sum, n) => sum + n, 0);
        this.data[1].value = _.reduce(this.widgetData.warningCount, (sum, n) => sum + n, 0);
        this.data[2].value = _.reduce(this.widgetData.failedCount, (sum, n) => sum + n, 0);
        this.data[3].value = _.reduce(this.widgetData.inProgressCount, (sum, n) => sum + n, 0);

        this.data[0].graph = this.widgetData.successCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        });
        this.data[1].graph = this.widgetData.warningCount ? this.widgetData.warningCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        }) : [];
        this.data[2].graph = this.widgetData.failedCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        });
        this.data[3].graph = this.widgetData.inProgressCount ? this.widgetData.inProgressCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        }) : [];

        this.renderCounter++;
    }

}

JobsWidgetController.$inject = ['$scope', '$filter', '$rootScope', 'styleService', 'dashboardService', 'sharedPersistenceService'];

const jobsWidgetController = {
    controller: JobsWidgetController,
    template: require('./jobsWidget.template.html'),
    bindings: { widgetData: '<' },
};

module.exports = jobsWidgetController;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/jobsWidget/jobsWidget.component.js